<template>
  <!--  底部公共组件-->
  <div>
    <div id="footerId">
      <div class="titleClass">
        <img src="../../../assets/images/footerImg.png"/>
        <div class="titleDesc">
          秉承“一家人，一个梦想、一份事业”的团队精神，积极从外部引入与恒通源价值观高度贴合的高端人才20多名。企业要有崇高的使命感，企业家要有伟大的格局和持续的创新能力。“天道昭昭，变者恒通”创新思变是恒通源的基因。恒通源秉持“让物流更高效”的使命，践行“创新思变、成就客户、诚信合作、共享共赢”的价值观，发挥自身优势，致力于成为商用车领域完全互联的供应链方案提供商。
        </div>
      </div>
      <div class="hr"/>
      <div class="footerMenuClass">
        <ul>
          <li>IoT服务</li>
          <li @click="toPath('/lotService')">车队管理</li>
          <li @click="toPath('/lotService')">数字货运</li>
        </ul>
        <ul>
          <li>物流装备服务</li>
          <li @click="toPath('/logisticsService')">车前资产服务</li>
          <li @click="toPath('/logisticsService')">车后资产服务</li>
        </ul>
        <ul>
          <li>金融服务</li>
          <li @click="toPath('/buyFinancial')">购车金融</li>
          <li @click="toPath('/theCarFinancial')">用车金融</li>
          <li @click="toPath('/productValueAdded')">二手车金融</li>
          <li @click="toPath('/financialService')">供应链金融</li>
        </ul>
        <ul>
          <li>关于我们</li>
          <li @click="toPath('/abstract')">企业简介</li>
          <li @click="toPath('/teamManage')">管理团队</li>
          <li @click="toPath('/joinUs')">加入我们</li>
        </ul>
        <ul>
          <li>联系我们</li>
          <li>客服热线</li>
          <li class="phone">029-89109236</li>
          <li v-if="false">合作邮箱</li>
          <li v-if="false" class="phone">XXX@hengtongyuan.cn</li>
        </ul>
        <div class="qrClass">
          <div>
            <img src="../../../assets/images/publicImg.png"/>
            <p>集团公众号</p>
          </div>
          <div>
            <img src="../../../assets/images/videoImg.png"/>
            <p>集团视频号</p>
          </div>
        </div>
      </div>
    </div>
    <!--    版权信息-->
    <div class="copyrightClass">
      <span>恒通源企业管理有限公司 @版权所有 <a target="_blank" href="https://beian.miit.gov.cn/">陕ICP备18020146号-5</a> 技术支持：诺鑫科技</span>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toPath(to) {
      this.$router.push(to)
    }
  }
}
</script>
<style lang="scss" scoped>
.copyrightClass {
  height: 46px;
  background-color: #1C1D20;
  display: flex;
  align-items: center;
  justify-content: center;

  span, a {
    font-size: 14px;
    opacity: 0.3;
    color: #fff;
  }

  a {
    opacity: 1;
  }
}

#footerId {
  background-color: #3F404A;
  padding: 42px 360px;

  .footerMenuClass {
    display: flex;
    margin-top: 23px;
    justify-content: space-between;

    .qrClass {
      display: flex;
      justify-content: space-between;
      margin-top: 57px;
      width: 221px;

      img {
        width: 90px;
        height: 90px;
      }

      p {
        font-size: 18px;
        color: #C5C6C9;
        font-weight: 400;
        margin-top: 15px;
      }
    }

    ul {

      li:nth-child(1) {
        font-size: 20px;
        color: #FFF;
        font-weight: 500;
        cursor: text;
      }

      .phone {
        color: #fff;
        font-size: 20px;
        cursor: text;
      }

      li {
        font-size: 16px;
        opacity: 0.5;
        line-height: 40px;
        color: #C5C6C9;
        list-style: none;
        cursor: pointer;
      }
    }
  }

  .hr {
    border: 1px solid #fff;
    margin-top: 55px;
    opacity: 0.1;
  }

  .titleClass {
    display: flex;
    align-items: center;

    img {
      width: 184px;
      height: 57px;
    }

    .titleDesc {
      margin-left: 37.5px;
      font-size: 16px;
      opacity: 0.5;
      color: #fff;
      line-height: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/footer/footer.vue